module.exports = "/_next/static/typing.gif";